"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");

var unifiBaseTheme_1 = __importDefault(require("./unifiBaseTheme"));

var parentTheme = styles_1.createMuiTheme(unifiBaseTheme_1.default);
var colorPrimary = '#1F496B';
var colorPrimaryDark = '#032a40';
var colorPrimaryLight = '#35759C';
var colorSecondary = '#8DC319';
var colorSecondaryDark = '#66AA00';
var colorSecondaryText = '#1F7400';
var nelnetTaskTheme = {
  themeName: 'Nelnet Task',
  palette: {
    primary: {
      main: colorPrimary,
      light: colorPrimaryLight,
      dark: colorPrimaryDark,
      contrastText: '#fff'
    },
    secondary: {
      main: colorSecondary,
      dark: colorSecondaryDark,
      contrastText: 'rgba(0,0,0,0.87)'
    }
  },
  typography: {
    h1: {
      fontSize: '1.25rem',
      fontWeight: 600
    },
    h2: {
      fontSize: '1rem',
      fontWeight: 400
    },
    h3: {
      textTransform: 'uppercase',
      fontWeight: 400,
      fontSize: '1rem'
    },
    h4: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.33
    },
    h5: {
      fontSize: '0.875rem',
      fontStyle: 'italic',
      fontWeight: 600,
      lineHeight: 1.33
    },
    h6: {
      fontSize: '0.875rem',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: 1.33
    },
    paragraph: {},
    body1: {
      fontSize: '1rem',
      fontWeight: 400
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0'
    },
    subtitle1: {
      fontSize: '1rem',
      lineHeight: '1.33'
    },
    subtitle2: {
      fontSize: '0.75em',
      letterSpacing: '0.025em',
      fontWeight: 600
    },
    caption: {
      fontSize: '0.75em',
      letterSpacing: '0.025em'
    },
    overline: {
      fontSize: '0.75rem',
      letterSpacing: '.127em'
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 600,
      letterSpacing: 0,
      textTransform: 'initial'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        letterSpacing: 0
      },
      containedPrimary: {
        backgroundColor: colorSecondary,
        color: 'rgba(0,0,0,0.87)',
        '&:hover': {
          backgroundColor: colorSecondaryDark
        },
        '&:focus': {
          backgroundColor: colorSecondaryDark,
          boxShadow: "0 0 0 4px " + colorManipulator_1.darken(colorSecondary, 0.4)
        }
      },
      containedSecondary: {
        backgroundColor: colorPrimary,
        color: '#fff',
        '&:hover': {
          backgroundColor: colorPrimaryDark
        },
        '&:focus': {
          backgroundColor: colorPrimaryDark,
          boxShadow: "0 0 0 4px " + colorManipulator_1.lighten(colorPrimary, 0.4)
        }
      },
      outlinedSecondary: {
        color: colorSecondaryText,
        borderColor: colorSecondaryText
      },
      textSecondary: {
        color: colorSecondaryText
      },
      sizeSmall: {
        fontSize: '0.8125rem'
      }
    },
    MuiButtonGroup: {
      grouped: {
        borderColor: parentTheme.palette.grey[500] + " !important",
        '&.UnifiButtonGroup-active': {
          color: 'rgba(0,0,0,0.87) !important',
          backgroundColor: parentTheme.palette.grey[300] + " !important"
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: colorPrimary
        }
      }
    },
    MuiDialogTitle: {
      root: {
        '&, & h6': {
          fontSize: '24px',
          fontWeight: 400,
          fontStyle: 'initial'
        }
      }
    },
    MuiFilledInput: {
      underline: {
        '&::after': {
          borderBottomColor: colorPrimary
        }
      }
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: colorPrimary
        }
      }
    },
    UnifiDataListItem: {
      datalistKey: {
        textTransform: 'none',
        fontWeight: 'normal',
        color: parentTheme.palette.grey[600],
        fontSize: 'inherit'
      },
      datalistValue: {
        fontWeight: '600'
      }
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: colorPrimary
        }
      }
    },
    MuiSwitch: {
      colorSecondary: {
        '&$checked': {
          color: colorPrimary,
          '& + .MuiSwitch-track': {
            backgroundColor: '#1F496B'
          }
        }
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: colorPrimary
      }
    },
    MuiTypography: {
      root: {
        '& [class*=scaleXlarge]': {
          fontSize: '175%'
        },
        '& [class*=scaleLarge]': {
          fontSize: '150%'
        }
      },
      colorSecondary: {
        color: colorSecondaryText
      }
    },
    UnifiPanelHeader: {
      title: {
        '&.MuiTypography-button': {
          textTransform: 'uppercase',
          fontWeight: 400,
          fontSize: '1rem'
        },
        '& button': {
          fontStyle: 'inherit'
        }
      }
    },
    UnifiStepLabel: {
      indicatorActive: {
        '&::before': {
          backgroundColor: colorSecondaryDark,
          color: 'rgba(0,0,0,0.87)'
        }
      },
      indicatorCompleted: {
        '&::before': {
          backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='none' stroke='rgba(0, 0, 0, 0.87)' stroke-width='3' d='M1.73 12.91l6.37 6.37L22.79 4.59'/%3E%3C/svg%3E\")"
        }
      }
    }
  }
};
exports.default = nelnetTaskTheme;